import styled from "styled-components";

export const Button = styled.button`
  @media ${(p) => p.theme.breakpoints.lg} {
    display: block;
  }

  border-radius: ${(p) => (p.naked ? "0px" : "40px")};
  border: ${(p) =>
    p.naked
      ? "none"
      : `2px solid ${p.theme.colors.border[p.color]} !important`};
  overflow: hidden;
  transition: 0.25s ease all;
  /* box-shadow: ${(p) =>
    p.naked ? "none" : "2px 2px 10px 0px rgba(0,0,0,0.33)"}; */

  width: ${(p) => (p.fluid ? "100%" : "fit-content")};
  padding: ${(p) => (p.naked ? "0px" : "10px 30px")};
  background-color: ${(p) =>
    p.naked || p.inverted
      ? "transparent"
      : p.color
      ? p.theme.colors[p.color]
      : "#f5f5f5"};
  //border: none;
  //border-radius: 4px;

  transition: all 250ms ease;

  &:disabled {
    cursor: default !important;
    opacity: 0.5;
  }

  &:hover {
    background-color: ${(p) =>
      p.naked
        ? "transparent"
        : p.inverted
        ? "rgba(0,0,0,0.1)"
        : p.disabled
        ? "inherit"
        : p.theme.colors[p.color] + "EE"};
    // color: ${(p) => (p.inverted ? p.theme.colors.on[p.color] : "inherit")};
    text-decoration: ${(p) => (p.naked ? "underline" : "none")};
  }

  min-height: 50px;
  margin-bottom: 12px;
  ${(p) => p.inlineCSS}
`;

export const ButtonInner = styled.div`
  font-size: 1rem;
  color: ${(p) =>
    p.naked
      ? "inherit"
      : p.inverted
      ? p.theme.colors.text[p.color]
      : p.color
      ? p.theme.colors.on[p.color]
      : "#000"};
  font-weight: bold;
  border-radius: 4px;
  white-space: nowrap;
`;
